import { render } from "./PendingView.vue?vue&type=template&id=047ff693&scoped=true"
import script from "./PendingView.vue?vue&type=script&lang=js"
export * from "./PendingView.vue?vue&type=script&lang=js"

import "./PendingView.vue?vue&type=style&index=0&id=047ff693&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047ff693"]])

export default __exports__